export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9551.1c96178b.jpg";